module.exports = __webpack_public_path__ + "static/media/25_logo1.368addc5.png";